export default "__VITE_ASSET__iRN8hgNCsF5UnncHSkX4dw__"